import { render, staticRenderFns } from "./priceSet.vue?vue&type=template&id=2ab3e048&scoped=true"
import script from "./priceSet.vue?vue&type=script&lang=js"
export * from "./priceSet.vue?vue&type=script&lang=js"
import style0 from "./priceSet.vue?vue&type=style&index=0&id=2ab3e048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3e048",
  null
  
)

export default component.exports